export default {
  app: {
    title: "Traum‑Vokabelbox",
    language: "Deutsch"
  },

  pages: {
    app: {
      myAccount: "Mein Konto",
      editProfile: "Profil bearbeiten",

      boxScenarios: "Box-Szenarien",
      scenario1Title: "Halbtags-Box",
      scenario1Desc: "Überprüfe die Box alle halben Tage (z. B. morgens und abends).",

      scenario2Title: "Tägliche Box",
      scenario2Desc: "Überprüfe die Box einmal pro Tag.",

      scenario3Title: "Tage nach Boxnummer",
      scenario3Desc: "Überprüfe die Box entsprechend ihrer Nummer (z. B. Box 3 alle 3 Tage).",

      username: "Benutzername",
      usernameHint: "Dein eindeutiger Benutzername für die Anmeldung",

      name: "Name",
      nameHint: "Wie sollen wir dich nennen?",

      email: "E-Mail-Adresse",
      emailHint: "E-Mail zur Passwortwiederherstellung (optional)",

      changePassword: "Passwort ändern",
      changePasswordHint: "Wenn du das Passwort nicht ändern möchtest, lasse dieses Feld leer (optional)",

      logout: "Abmelden",
      confirmLogout: "Abmeldung bestätigen",
      confirmLogoutText: "Möchtest du dich wirklich abmelden?",
      cancel: "Abbrechen",

      close: "Schließen",
      updateProfile: "Profil aktualisieren",

      myWords: "Meine Wörter",
      addNewWord: "Neues Wort / neue Redewendung hinzufügen",
      boxes: "Boxen",

      applicationSettings: "App-Einstellungen",

      autoSpeechOnChecking: "Wort automatisch abspielen, wenn es angezeigt wird",
      autoDetectClipboardChange: "Zwischenablage-Text automatisch erkennen",

      clipboardPermissionText: "Die App benötigt in den Browsereinstellungen die Berechtigung für den Zugriff auf die Zwischenablage. Für weitere Hilfe hier klicken.",

      clipboardHelpTitle: "So aktivierst du den Zugriff auf die Zwischenablage",

      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",

      chromeStep1: "Öffne den Chrome-Browser.",
      chromeStep2: "Gehe zu den Browsereinstellungen.",
      chromeStep3: "Suche den Bereich Website-Einstellungen oder Einstellungen.",
      chromeStep4: "Gehe zu Berechtigungen und aktiviere die Zwischenablage.",

      firefoxStep1: "Öffne den Firefox-Browser.",
      firefoxStep2: "Gehe zu den Browsereinstellungen.",
      firefoxStep3: "Suche den Bereich Berechtigungen und aktiviere den Zugriff auf die Zwischenablage.",

      safariStep1: "Öffne die Einstellungen deines Telefons.",
      safariStep2: "Gehe zu Safari.",
      safariStep3: "Suche nach Einstellungen zur Zwischenablage und aktiviere sie.",

      otherBrowserTitle: "Wenn du einen anderen Browser verwendest",
      otherBrowserStep1: "Suche in den Browsereinstellungen nach einer ähnlichen Option wie Berechtigungen oder Website-Einstellungen und aktiviere den Zugriff auf die Zwischenablage.",

      speechNotSupported: "Dein Browser unterstützt SpeechSynthesis nicht",

      ttsSettings: "Text-zu-Sprache-Einstellungen",
      sampleText: "Text zum Testen der Sprachausgabe",

      rate: "Geschwindigkeit",
      rateHint: "Steuert die Sprechgeschwindigkeit.",

      pitch: "Tonhöhe",
      pitchHint: "Passt die Tonhöhe der Stimme an.",

      volume: "Lautstärke",
      volumeHint: "Legt die Lautstärke der Sprachausgabe fest.",

      friends: "Freunde",
      messages: "Nachrichten",

      addToMyWords: "{word} zu meinen Wörtern hinzufügen",
      viewInMyList: "{word} in meiner Liste anzeigen",

      wordSuggestion: "Wortvorschlag",
      goToAddWord: "Zum Hinzufügen eines neuen Wortes gehen",

      updateCompleted: "Aktualisierung erfolgreich abgeschlossen",
      latestChanges: "Neueste Änderungen in den letzten Versionen",
      version: "Version",
      gotIt: "Verstanden"
    },

    addVocabulary: {
      title: "Neues Wort hinzufügen",
      add: "Hinzufügen",
      word: "Wort / Ausdruck",
      meaning: "Bedeutung",
      example: "Beispiel",
      description: "Beschreibung"
    },

    vocabularies: {
      searchLabel: "Text suchen",
      listLength: "Listenlänge",
      boxNumber: "Boxnummer",
      nothingFound: "Nichts gefunden !!!",
      adjustFilters: "Bitte versuche, deine Filter anzupassen",
      tableWord: "Wort",
      tableAction: "Aktion",
      showDetails: "Details anzeigen",
      completeInfo: "Vollständige Informationen",
      meaning: "Bedeutung",
      example: "Beispiel",
      description: "Beschreibung",
      close: "Schließen",
      editTitle: "Bearbeiten",
      editBtn: "Bearbeiten",
      deleteTitle: "{word} entfernen",
      deleteConfirmText: "Möchtest du diesen Vokabeleintrag wirklich löschen? Bitte beachte, dass er nach dem Löschen nicht wiederhergestellt werden kann.",
      yes: "Ja!",
      no: "Nein"
    },

    messages: {
      wordSuggestions: "Wortvorschläge"
    },

    login: {
      signInTitle: "Anmelden",
      signInBtn: "Anmelden",
      registerTitle: "Registrieren",
      registerBtn: "Registrieren",
      registerLink: "Registrieren",
      username: "Benutzername",
      password: "Passwort",
      nickname: "Name",
      email: "E-Mail-Adresse",
      noAccount: "Noch nicht registriert?",
      haveAccount: "Ich habe ein Konto.",
      usernameHint: "Dein eindeutiger Benutzername für die Anmeldung",
      nicknameHint: "Wie sollen wir dich nennen?",
      emailHint: "E-Mail zur Passwortwiederherstellung (optional)",
      passwordHint: "Passwort ohne Regeln, gib ein, was du möchtest",
      orContinueWith: "Oder fortfahren mit...",
      guestRegister: "Schnell als Gast registrieren 😒"
    },

    reviewVocabulary: {
      showMeaning: "Bedeutung anzeigen",
      hideMeaning: "Bedeutung ausblenden",
      meaning: "Bedeutung",
      example: "Beispiel",
      description: "Beschreibung",
      playPhrase: "PlayPhrase.me",
      prev: "Zurück",
      next: "Weiter"
    },

    checkVocabulary: {
      showMeaning: "Bedeutung anzeigen",
      hideMeaning: "Bedeutung ausblenden",
      wordsRemain: "Verbleibende Wörter",
      lastOne: "Letztes",
      meaning: "Bedeutung",
      example: "Beispiel",
      description: "Beschreibung",
      playPhrase: "PlayPhrase.me",
      iRemember: "Ich erinnere mich",
      iDontRemember: "Ich erinnere mich nicht"
    },

    boxes: {
      all: "Alle Boxen anzeigen",
      box: "Box",
      empty: "Leer",
      needsChecking: "Muss überprüft werden",
      checked: "Überprüft",

      total: "Gesamt",
      waiting: "Wartend",
      waitingForCheck: "Wartet auf Überprüfung",

      closestReview: "Nächste Wiederholung",
      notScheduled: "Noch nicht geplant",

      deeplyMemorized: "Du hast {count} Wörter dauerhaft verinnerlicht.",
      notReachedYet: "Ups! Du hast diese Box noch nicht erreicht.",

      startChecking: "Überprüfung starten",
      review: "Wiederholen",
      viewAllWords: "Alle Wörter anzeigen",
      addNew: "Neu hinzufügen",
      itsEmpty: "Sie ist leer"
    },

    friends: {
      searchInUsers: "Unter Benutzern suchen",
      searchList: "Suchliste",
      noUsersYet: "Es gibt noch keine Benutzer.",
      searchUsersAndSendRequest: "Du kannst Benutzer suchen und eine Freundschaftsanfrage senden",
      friendList: "Freundesliste",
      noFriendsYet: "Es gibt noch keine Freunde."
    }
  },

  plugins: {
    axios: {
      postRequestError: "Beim Senden der Anfrage ist ein Fehler aufgetreten"
    }
  },

  components: {
    shareButton: {
      shareTitle: "{word} teilen",
      messageOptional: "Nachricht (optional)"
    },

    userList: {
      cancelRequest: "Anfrage abbrechen",
      unfriend: "Freund entfernen",
      sendRequest: "Anfrage senden",
      accept: "Akzeptieren",
      reject: "Ablehnen",

      share: "Teilen",
      addedBefore: "Bereits zuvor hinzugefügt",

      deeplyMemorized: "{name} hat {count} Wörter dauerhaft verinnerlicht.",
      notReachedBox: "{name} hat diese Box noch nicht erreicht.",

      totalVocabularies: "Gesamte Vokabeln",
      registerAge: "Registrierungsdauer",
      lastCheck: "Letzte Überprüfung",
      lastAddedVocabulary: "Zuletzt hinzugefügte Vokabel",
      totalChecks: "Gesamte Überprüfungen",
      averageDailyCheck: "Durchschnittliche tägliche Überprüfungen",
      averageDailyLearnedCheck: "Durchschnittliche tägliche gelernte Überprüfungen",
      averageDailyNotLearnedCheck: "Durchschnittliche tägliche nicht gelernte Überprüfungen",
      averageDailyAdd: "Durchschnittliche tägliche Hinzufügungen"
    }
  },

  public: {
    close: "Schließen"
  },
  "apiResultStatusCodes": {
    "0": "Vorgang fehlgeschlagen",
    "1": "Vorgang erfolgreich",
    "2": "Ein Fehler ist aufgetreten",
    "3": "Ungültige gesendete Parameter",
    "4": "Nicht gefunden",
    "5": "Authentifizierungsfehler",
    "6": "Dieses Element wurde bereits registriert",
    "7": "Dieser Benutzer wurde bereits registriert",
    "8": "Der angegebene Benutzer existiert nicht",
    "9": "Falsches Passwort",
    "10": "Ungültige Parameter",
    "11": "Anmeldung fehlgeschlagen",
    "12": "Zugriff verweigert",
    "13": "Element nicht gefunden",
    "14": "Dieser Benutzername ist bereits vergeben",
    "15": "Diese E-Mail-Adresse wird bereits verwendet",
    "16": "Benutzername ist erforderlich",
    "17": "Spitzname ist erforderlich",
    "18": "Passwort ist erforderlich",
    "19": "Der Benutzername darf keine Leerzeichen enthalten",
    "20": "Registrierung erfolgreich abgeschlossen",
    "21": "Anmeldung erfolgreich",
    "22": "Das Passwort darf keine Leerzeichen enthalten",
    "23": "Vokabel erfolgreich hinzugefügt",
    "24": "Vokabel erfolgreich aktualisiert",
    "25": "Vokabel erfolgreich gelöscht",
    "26": "Du hast diese Vokabel bereits hinzugefügt",
    "27": "Das Wort ist erforderlich",
    "28": "Keine Vokabeln gefunden",
    "29": "Glückwunsch! Alle Wörter in dieser Box wurden überprüft",
    "30": "Du kannst das Wortfeld nicht ändern",
    "31": "Bitte fülle die erforderlichen Felder aus",
    "32": "Keine Änderungen gefunden",
    "33": "Der angegebene Benutzer existiert nicht im Repository",
    "34": "Freundschaftsanfrage erfolgreich gesendet",
    "35": "Freundschaftsanfrage erfolgreich angenommen",
    "36": "Freundschaftsanfrage erfolgreich storniert",
    "37": "Freundschaft erfolgreich beendet",
    "38": "Anfrage erfolgreich abgelehnt",
    "39": "Nachricht erfolgreich gesendet"
  },
  "time": {
    "day": "Tag | Tage",
    "hour": "Stunde | Stunden",
    "minute": "Minute | Minuten"
  }



}
